import React from "react";
import "./styles.css";

/**
 * Tarjeta atómica con un icono circular en la parte superior y un label debajo.
 * El icono se recibe como nodo (puede ser un componente MUI, un <img />, etc.).
 */
export const FeatureCard = ({ icon, label, className = "" }) => {
  return (
    <div className={`feature-card ${className}`.trim()}>
      <div className="feature-card__icon" aria-hidden="true">
        {icon}
      </div>
      <p className="feature-card__label">{label}</p>
    </div>
  );
};
